import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ModeloDocumentoDados } from '../modelo-documento.model'
import { ModeloDocumentoService } from '../modelo-documento.service'

@Component({
  selector: 'app-form-divulgacao-titulos',
  templateUrl: './form-divulgacao-titulos.component.html',
})
export class FormDivulgacaoTitulosComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  @Input() concursoId!: number
  @Output() formData = new EventEmitter<Record<string, string>>()

  dados?: ModeloDocumentoDados
  campos: Record<string, string> = {}
  examinadores: string[] = []
  candidatos: string[] = []

  constructor(private service: ModeloDocumentoService) {}

  ngOnInit(): void {
    this.service.obterDados(this.concursoId, 'DIVULGACAO_TITULOS')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(d => {
        this.dados = d
        this.campos = { ...d.camposEditaveis }
        this.emitir()
        const titulosKey = Object.keys(d.notasPorProva).find(k => k.includes('Títulos')) || ''
        const notas = titulosKey ? d.notasPorProva[titulosKey] : []
        this.examinadores = [...new Set(notas.map(n => n.examinador))]
        this.candidatos = [...new Set(notas.map(n => `${n.inscricaoId} - ${n.candidato}`))]
      })
  }

  getNota(candidato: string, examinador: string): string {
    const titulosKey = Object.keys(this.dados?.notasPorProva || {}).find(k => k.includes('Títulos')) || ''
    const notas = titulosKey ? this.dados!.notasPorProva[titulosKey] : []
    return notas.find(n => `${n.inscricaoId} - ${n.candidato}` === candidato && n.examinador === examinador)?.nota || ''
  }

  onCamposChange(campos: Record<string, string>): void {
    this.campos = { ...this.campos, ...campos }
    this.emitir()
  }

  emitir(): void { this.formData.emit(this.campos) }
}
